import React from "react";
import { Portal } from "react-overlays";
export const PickerContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};
